/* eslint-disable linebreak-style */
/* eslint-disable react/jsx-filename-extension */
/* eslint-disable import/extensions */

import React from 'react';

import { Fade } from 'react-awesome-reveal';

import Button from '../elements/Button';

export default function Discuss() {
  return (
    <section className="py-20" id="get-involved-cta">
      <div className="container mx-auto px-4">
        <Fade direction="up" triggerOnce>
          <div className="relative overflow-hidden rounded-3xl bg-gradient-to-br from-theme-purple via-dark-theme-purple to-theme-blue p-12 md:p-16 lg:p-20">
            {/* Background decoration */}
            <div className="absolute top-0 right-0 w-96 h-96 bg-theme-gold/10 rounded-full blur-3xl -translate-y-1/2 translate-x-1/2" />
            <div className="absolute bottom-0 left-0 w-64 h-64 bg-theme-purple/30 rounded-full blur-3xl translate-y-1/2 -translate-x-1/2" />

            <div className="relative z-10 flex flex-col lg:flex-row items-center justify-between gap-10">
              <div className="lg:w-2/3 text-center lg:text-left">
                <p className="text-light-theme-purple text-sm font-medium uppercase tracking-wider mb-4">
                  Ready to take part?
                </p>
                <h2 className="text-4xl md:text-5xl lg:text-6xl font-serif font-bold text-white leading-tight mb-6">
                  Be part of the
                  <br />
                  <span className="text-theme-gold">next chapter</span>
                </h2>
                <p className="text-lg text-gray-200 max-w-xl">
                  Whether you want to enroll a young person, volunteer as a mentor, or
                  partner with us — we read every message.
                </p>
              </div>

              <div className="flex flex-col sm:flex-row lg:flex-col gap-4">
                <Fade direction="up" delay={200} triggerOnce>
                  <Button
                    href="/get-involved"
                    type="link"
                    className="flex items-center justify-center px-8 py-5 bg-theme-gold text-theme-blue font-semibold text-lg rounded-xl shadow-xl hover:bg-theme-gold-dark transition-all duration-300 cursor-pointer group"
                  >
                    Get Involved
                    <svg className="w-5 h-5 ml-2 group-hover:translate-x-1 transition-transform" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                      <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M17 8l4 4m0 0l-4 4m4-4H3" />
                    </svg>
                  </Button>
                </Fade>
                <Fade direction="up" delay={400} triggerOnce>
                  <Button
                    href="/donate"
                    type="link"
                    className="flex items-center justify-center px-8 py-5 bg-transparent text-white font-semibold text-lg rounded-xl border-2 border-white/40 hover:bg-white/10 hover:border-white/60 transition-all duration-300 cursor-pointer"
                  >
                    Donate
                  </Button>
                </Fade>
              </div>
            </div>

            <Fade direction="up" delay={600} triggerOnce>
              <div className="relative z-10 mt-12 pt-8 border-t border-white/10">
                <div className="flex flex-wrap justify-center lg:justify-start gap-8 text-center lg:text-left">
                  <div>
                    <p className="text-2xl font-serif font-bold text-white">Free</p>
                    <p className="text-sm text-gray-300">For youth</p>
                  </div>
                  <div>
                    <p className="text-2xl font-serif font-bold text-white">1-on-1</p>
                    <p className="text-sm text-gray-300">Mentorship pairing</p>
                  </div>
                  <div>
                    <p className="text-2xl font-serif font-bold text-white">501(c)(3)</p>
                    <p className="text-sm text-gray-300">Pending</p>
                  </div>
                  <div>
                    <p className="text-2xl font-serif font-bold text-white">Local</p>
                    <p className="text-sm text-gray-300">Cleveland-rooted</p>
                  </div>
                </div>
              </div>
            </Fade>
          </div>
        </Fade>
      </div>
    </section>
  );
}
